import { MobXProviderContext } from 'mobx-react';
import {
  usePollConversation,
  usePollConversations,
} from 'Modules/conversation/conversations-list/requests/index.requests';
import { useContext } from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { PollingConfig } from '../index.types';

const useConversationsPollingV2 = ({
  pollingEnabled,
  intervalFunction,
}: PollingConfig) => {
  const {
    conversation: { CurrentConversation },
  } = useContext<RootStoreProps>(MobXProviderContext);

  const { refetch: refetchConversations } = usePollConversations(
    pollingEnabled,
    intervalFunction
  );

  const { refetch: refetchConversation } = usePollConversation(
    pollingEnabled,
    CurrentConversation?.id
  );

  return {
    refetchConversations,
    refetchConversation,
  };
};

export default useConversationsPollingV2;
